// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-page {
  max-width: var(--page-max);
  margin: 0 auto;
  padding: 2.25rem 1.5rem 4rem;
}

.help-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
  max-width: 44rem;
  margin-bottom: 2.5rem;
}

.help-head h1 {
  margin: 0;
}

.help-head > p {
  margin: 0;
  font-size: 1.08rem;
}

.help-search {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 0.75rem;
  color: var(--text-tertiary);
}

.help-search > svg {
  position: absolute;
  left: 0.95rem;
  pointer-events: none;
}

.help-search input {
  width: 100%;
  min-height: 52px;
  padding-left: 2.85rem;
  padding-right: 2.85rem;
  font-size: 1.05rem;
}

.help-search input::-webkit-search-cancel-button {
  display: none;
}

.help-search-clear {
  position: absolute;
  right: 0.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-height: 40px;
  background: transparent;
  color: var(--text-secondary);
}

.help-section-title {
  margin: 0 0 1.1rem;
}

/* Symptome */
.help-symptoms {
  margin-bottom: 3rem;
}

.symptom-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid var(--border-primary);
  border-left: 1px solid var(--border-primary);
}

.symptom {
  display: grid;
  gap: 0.25rem;
  padding: 0.9rem 1rem;
  border-right: 1px solid var(--border-primary);
  border-bottom: 1px solid var(--border-primary);
  color: var(--text-primary);
}

.symptom:hover {
  background: var(--accent-soft);
  color: var(--text-primary);
}

.symptom {
  align-content: start;
  gap: 0.55rem;
}

.symptom-screen {
  justify-self: start;
  font-family: var(--font-mono);
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.4;
  padding: 0.25rem 0;
}

/* Anzeige wie auf dem Uhrendisplay */
.symptom-screen.on-watch {
  justify-self: start;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: #0b1416;
  box-shadow: inset 0 0 0 1px #24383c;
  color: #e9f4f1;
  font-family: var(--font-mono);
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.4;
}

.symptom:hover .symptom-screen.on-watch {
  color: #6bd8c8;
}

.symptom-what {
  font-size: 0.88rem;
  color: var(--text-secondary);
}

/* Anleitungen */
.help-guides {
  margin-bottom: 3rem;
}

.guide-link-title {
  display: block;
  font-weight: 700;
}

.guide-link-desc {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.88rem;
  color: var(--text-secondary);
}

/* FAQ */
.faq-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.faq-filter-btn {
  min-height: 36px;
  padding: 0.35rem 0.7rem;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-secondary);
  font-family: var(--font-mono);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.faq-filter-btn:hover {
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.faq-filter-btn.active {
  background: var(--text-primary);
  border-color: var(--text-primary);
  color: var(--bg-primary);
}

.help-faq-list,
.help-result-group {
  border-top: 1px solid var(--border-primary);
}

.help-faq {
  border-bottom: 1px solid var(--border-primary);
  scroll-margin-top: calc(var(--header-height) + 1rem);
}

.help-faq-q {
  margin: 0;
  font-family: var(--font-body);
  font-size: 1.02rem;
  text-transform: none;
}

.help-faq-q button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  min-height: 52px;
  padding: 0.75rem 0;
  background: transparent;
  color: var(--text-primary);
  font: inherit;
  font-weight: 700;
  text-align: left;
}

.help-faq-sign {
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 1.15rem;
  color: var(--accent-primary);
}

.help-faq-a {
  max-width: 44rem;
  padding: 0 0 1.1rem;
}

.help-faq-a p {
  color: var(--text-secondary);
}

.help-faq-link {
  min-height: 32px;
  padding: 0;
  background: transparent;
  color: var(--text-tertiary);
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.help-faq-link:hover {
  color: var(--accent-primary);
}

/* Ergebnisse */
.help-results > .ui-eyebrow {
  margin: 0 0 1rem;
}

.help-result-group {
  margin-bottom: 2rem;
}

.help-result-group h2 {
  margin: 1rem 0 0.25rem;
  font-size: 1.25rem;
}

.help-empty p {
  margin: 0.25rem 0;
}

.help-contact {
  margin-top: 3rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-primary);
}

@media (max-width: 680px) {
  .symptom-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .help-page {
    padding: 1.5rem 1rem 3rem;
  }
}

.help-result-guide {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/HelpPage.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,6CAA6C;EAC7C,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".help-page {\n  max-width: var(--page-max);\n  margin: 0 auto;\n  padding: 2.25rem 1.5rem 4rem;\n}\n\n.help-head {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0.75rem;\n  max-width: 44rem;\n  margin-bottom: 2.5rem;\n}\n\n.help-head h1 {\n  margin: 0;\n}\n\n.help-head > p {\n  margin: 0;\n  font-size: 1.08rem;\n}\n\n.help-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-top: 0.75rem;\n  color: var(--text-tertiary);\n}\n\n.help-search > svg {\n  position: absolute;\n  left: 0.95rem;\n  pointer-events: none;\n}\n\n.help-search input {\n  width: 100%;\n  min-height: 52px;\n  padding-left: 2.85rem;\n  padding-right: 2.85rem;\n  font-size: 1.05rem;\n}\n\n.help-search input::-webkit-search-cancel-button {\n  display: none;\n}\n\n.help-search-clear {\n  position: absolute;\n  right: 0.35rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-height: 40px;\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.help-section-title {\n  margin: 0 0 1.1rem;\n}\n\n/* Symptome */\n.help-symptoms {\n  margin-bottom: 3rem;\n}\n\n.symptom-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  border-top: 1px solid var(--border-primary);\n  border-left: 1px solid var(--border-primary);\n}\n\n.symptom {\n  display: grid;\n  gap: 0.25rem;\n  padding: 0.9rem 1rem;\n  border-right: 1px solid var(--border-primary);\n  border-bottom: 1px solid var(--border-primary);\n  color: var(--text-primary);\n}\n\n.symptom:hover {\n  background: var(--accent-soft);\n  color: var(--text-primary);\n}\n\n.symptom {\n  align-content: start;\n  gap: 0.55rem;\n}\n\n.symptom-screen {\n  justify-self: start;\n  font-family: var(--font-mono);\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.4;\n  padding: 0.25rem 0;\n}\n\n/* Anzeige wie auf dem Uhrendisplay */\n.symptom-screen.on-watch {\n  justify-self: start;\n  padding: 0.25rem 0.6rem;\n  border-radius: 999px;\n  background: #0b1416;\n  box-shadow: inset 0 0 0 1px #24383c;\n  color: #e9f4f1;\n  font-family: var(--font-mono);\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.4;\n}\n\n.symptom:hover .symptom-screen.on-watch {\n  color: #6bd8c8;\n}\n\n.symptom-what {\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n\n/* Anleitungen */\n.help-guides {\n  margin-bottom: 3rem;\n}\n\n.guide-link-title {\n  display: block;\n  font-weight: 700;\n}\n\n.guide-link-desc {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n\n/* FAQ */\n.faq-filter {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.faq-filter-btn {\n  min-height: 36px;\n  padding: 0.35rem 0.7rem;\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.faq-filter-btn:hover {\n  border-color: var(--accent-primary);\n  color: var(--text-primary);\n}\n\n.faq-filter-btn.active {\n  background: var(--text-primary);\n  border-color: var(--text-primary);\n  color: var(--bg-primary);\n}\n\n.help-faq-list,\n.help-result-group {\n  border-top: 1px solid var(--border-primary);\n}\n\n.help-faq {\n  border-bottom: 1px solid var(--border-primary);\n  scroll-margin-top: calc(var(--header-height) + 1rem);\n}\n\n.help-faq-q {\n  margin: 0;\n  font-family: var(--font-body);\n  font-size: 1.02rem;\n  text-transform: none;\n}\n\n.help-faq-q button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n  min-height: 52px;\n  padding: 0.75rem 0;\n  background: transparent;\n  color: var(--text-primary);\n  font: inherit;\n  font-weight: 700;\n  text-align: left;\n}\n\n.help-faq-sign {\n  flex-shrink: 0;\n  font-family: var(--font-mono);\n  font-size: 1.15rem;\n  color: var(--accent-primary);\n}\n\n.help-faq-a {\n  max-width: 44rem;\n  padding: 0 0 1.1rem;\n}\n\n.help-faq-a p {\n  color: var(--text-secondary);\n}\n\n.help-faq-link {\n  min-height: 32px;\n  padding: 0;\n  background: transparent;\n  color: var(--text-tertiary);\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.help-faq-link:hover {\n  color: var(--accent-primary);\n}\n\n/* Ergebnisse */\n.help-results > .ui-eyebrow {\n  margin: 0 0 1rem;\n}\n\n.help-result-group {\n  margin-bottom: 2rem;\n}\n\n.help-result-group h2 {\n  margin: 1rem 0 0.25rem;\n  font-size: 1.25rem;\n}\n\n.help-empty p {\n  margin: 0.25rem 0;\n}\n\n.help-contact {\n  margin-top: 3rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--border-primary);\n}\n\n@media (max-width: 680px) {\n  .symptom-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .help-page {\n    padding: 1.5rem 1rem 3rem;\n  }\n}\n\n.help-result-guide {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
